import {version} from "../../../version";

export interface TabSession {
    // config
    configTab: number,
    editConfigMenuTab: number,
    configViewActiveItem: string,
    configRightSideTab: number,
    aiScripterResultTab: number,
    apiGatewayTesterTab: number,

    // converter
    converterTab: number,
    exportSimPreEditTab: number,
    exportSimOutputTab: number,
    importSimOutputTab: number,
    importSimTab: number,

    // scriptExecution
    scriptExecutionTab: number,
    multiScriptTab: number,
    multiOrderScriptTabMenu: number,
    scriptRunnerTypeIsCron: boolean,
    reportScriptTab: number,
    reportScriptResultTab: number

    // docViewer
    docViewerTab: number,
    matrixDocTab: number,
    matrixDocInputTab: number,
    ediOutputTab: number,

    // queues
    queuesTab: number,
    queueEditTab: number,
    testSuppressionScriptModalTab: number,

    // contracts
    contractsTab: number,
    contractListTab: number,
    customerAccountingTab: number,
    billingToolTab: number,

    // Scheduler
    schedulerTab: number,

    // systemStatus
    systemStatusTab: number,
    systemStatusMessageEditTab: number,
    longRunningQueriesTab: number,

    // transportOrder
    transportOrderRightSideTab: number,
    transportOrderFilesTab: number,

    // geostatus
    geostatus: number,

    // mongoHealthTab
    mongoHealthTab: number,

    // ftpTab
    ftpTab: number,
}

export const TAB_SESSION_STORAGE_KEY = "tab_session"

export const defaultTabSession: TabSession = {
    configTab: 0,
    editConfigMenuTab: 0,
    configViewActiveItem: "NavTree",
    configRightSideTab: 0,
    aiScripterResultTab: 0,
    apiGatewayTesterTab: 2,

    converterTab: 0,
    exportSimPreEditTab: 0,
    exportSimOutputTab: 0,
    importSimOutputTab: 0,
    importSimTab: 0,

    scriptExecutionTab: 0,
    multiScriptTab: 0,
    multiOrderScriptTabMenu: 0,
    scriptRunnerTypeIsCron: false,
    reportScriptTab: 0,
    reportScriptResultTab: 0,

    docViewerTab: 0,
    matrixDocTab: 0,
    matrixDocInputTab: 0,
    ediOutputTab: 0,

    queuesTab: 0,
    queueEditTab: 0,
    testSuppressionScriptModalTab: 0,

    contractsTab: 0,
    contractListTab: 0,
    customerAccountingTab: 0,
    billingToolTab: 0,

    schedulerTab: 0,

    systemStatusTab: 0,
    systemStatusMessageEditTab: 0,
    longRunningQueriesTab: 0,

    transportOrderRightSideTab: 0,
    transportOrderFilesTab: 0,

    geostatus: 0,

    mongoHealthTab: 0,

    ftpTab: 0,
}

export function restoreTabSession(): TabSession {
    try {
        const stored = JSON.parse(sessionStorage.getItem(TAB_SESSION_STORAGE_KEY))
        if (!stored || stored.version != version) {
            return {...defaultTabSession}
        }
        return {...defaultTabSession, ...stored.tabSession}
    } catch (ex) {
        console.log("[TabSession] unable to restore stored tab session", ex)
        return {...defaultTabSession}
    }
}

export function persistTabSession(tabSession: TabSession) {
    sessionStorage.setItem(TAB_SESSION_STORAGE_KEY, JSON.stringify({version, tabSession}))
}

export function clearTabSession() {
    sessionStorage.removeItem(TAB_SESSION_STORAGE_KEY)
}

export function clampTabIndex(activeIndex: number, panes: any[]): number {
    return Math.max(0, Math.min(activeIndex ?? 0, panes.length - 1))
}

export default TabSession
